export const cleanAddOnName = (name?: string) => {
  if (!name) {
    return name;
  }

  let cleaned = name
    .replaceAll("VPS SSD", "")
    .replaceAll("SSD VPS", "")
    .replaceAll("VPS,", "")
    .replaceAll("Idera", "R1Soft")
    .replaceAll("ServerBite", "");

  return cleaned.trim();
};
